import {
  SET_TOURNAMENT_INFORMATION_FOR_ADMIN,
  SET_RETURNING_TO_CALENDAR_FOR_ADMIN
} from './constants';

export const setTournamentInformation = tournament => ({
  type: SET_TOURNAMENT_INFORMATION_FOR_ADMIN,
  payload: tournament
});

export const setReturningToCalendar = () => ({
  type: SET_RETURNING_TO_CALENDAR_FOR_ADMIN
});



// WEBPACK FOOTER //
// ./src/features/admin/actionTypes.js